import React from 'react'
import useTranslation from '../shared/TranslationProvider'

const Outcomes = ({ outcomes }) => {
  const { t } = useTranslation('shared')
  return (
    <div className="rounded-[15px] bg-gradient-to-b from-[#0F80E2] to-[#00C2FF] sm:container">
      <div className="outcomes m-1 flex min-h-28 flex-col rounded-2xl bg-white p-2 sm:gap-2 sm:pt-4">
        <div className="subtitle">{t('unlock_insights')}</div>
        <ul>
          {outcomes.map((outcome, idx) => (
            <li className="text-sm" key={`outcome-${idx}`}>
              {outcome}
            </li>
          ))}
        </ul>
      </div>
    </div>
  )
}

export default Outcomes
